<template>
  <div
    class="2xl:w-9/12"
    :class="{
      'order-2 lg:order-1': index % 2 === 0, // Çift indexlerde yazı solda
      'order-1 lg:order-2': index % 2 !== 0, // Tek indexlerde yazı sağda
    }"
    data-aos="fade-up"
    data-aos-duration="500"
  >
    <div
      class="h-12 w-12 bg-primary/10 flex items-center justify-center rounded-lg"
    >
      <svg
        class="h-7 w-7 text-primary"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <rect id="bound" x="0" y="0" width="24" height="24"></rect>
          <path
            d="M10.8226874,8.36941377 L12.7324324,9.82298668 C13.4112512,8.93113547 14.4592942,8.4 15.6,8.4 C17.5882251,8.4 19.2,10.0117749 19.2,12 C19.2,13.9882251 17.5882251,15.6 15.6,15.6 C14.5814697,15.6 13.6363389,15.1780547 12.9574041,14.4447676 L11.1963369,16.075302 C12.2923051,17.2590082 13.8596186,18 15.6,18 C18.9137085,18 21.6,15.3137085 21.6,12 C21.6,8.6862915 18.9137085,6 15.6,6 C13.6507856,6 11.9186648,6.9294879 10.8226874,8.36941377 Z"
            id="Combined-Shape"
            fill="currentColor"
            opacity="0.3"
          ></path>
          <path
            d="M8.4,18 C5.0862915,18 2.4,15.3137085 2.4,12 C2.4,8.6862915 5.0862915,6 8.4,6 C11.7137085,6 14.4,8.6862915 14.4,12 C14.4,15.3137085 11.7137085,18 8.4,18 Z"
            id="Oval-14-Copy"
            fill="currentColor"
          ></path>
        </g>
      </svg>
    </div>

    <h1 class="text-3xl/tight font-medium mt-6 mb-4">
      {{ feature.HeadLine }}
    </h1>
    <p class="text-gray-500">
      {{ feature.Description }}
    </p>
    <div class="flex items-center mt-12">
      <a :href="feature.ButtonLink" class="text-primary">
        {{ feature.ButtonText }}
        <i class="fa-solid fa-arrow-right ms-2"></i>
      </a>
    </div>
  </div>
  <div
    class="relative"
    :class="{
      'order-1 lg:order-2': index % 2 === 0, // Çift indexlerde yazı solda
      'order-2 lg:order-1': index % 2 !== 0, // Tek indexlerde yazı sağda
    }"
  >
    <div class="hidden sm:block">
      <div
        class="after:w-20 after:h-20 after:absolute after:-top-8 after:-end-8 2xl:after:-end-8 after:bg-[url('../images/pattern/dot2.svg')]"
      ></div>
      <div
        class="before:w-20 before:h-20 before:absolute before:-bottom-8 before:-start-8 before:bg-[url('../images/pattern/dot5.svg')]"
      ></div>
    </div>

    <img
      :src="feature.MediaContent"
      alt="saas2"
      data-aos="fade-left"
      data-aos-duration="400"
    />
  </div>
</template>

<script setup>
import { defineProps, toRef } from "vue";

const props = defineProps({
  feature: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

const feature = toRef(props, "feature");
const index = toRef(props, "index");
</script>
